module.exports = __webpack_public_path__ + "img/lg_ring_r_l_0_0.f0f24397.png";